import { axios } from '@/utils/request'

//获取字典
export function getDict(dictName){
    return axios({
        url:"/sys/dict/getDictItems/" + dictName,
        method: 'get',
    })
}

//获取公告
export function getAnnountCement(){
    return axios({
        url: "/sys/annountCement/listPublicAnnouncement",
        method: 'get'
    })
}

//获取当前租户信息
export function getTenantInfo(){
    return axios({
        url: "/system/sysTenant/getCurrentTenantInfo"
    })
}

//获取当前租户配置
export function getTenantConfig(){
    return axios({
        url: "/system/sysTenant/getCurrentConfig"
    })
}

//获取当前网站配置
export function getSysConfig(){
    return axios({
        url: "/sys/config/getCurrentConfig"
    })
  }

  //获取菜单
  export function getMenu(){
      return axios({
          url: "/teaching/menu/getUserMenu"
      })
  }